import React, { FunctionComponent } from 'react';
import Page from '@/components/layout/Page';
import Header from '@/components/typography/Header';
import LandingPageLinkIndex from '@/components/landingPages/LandingPageLinkIndex';
import { ILandingPageLink } from '@/pageGeneration/services/LandingPageService';

interface IProps {
  items: ILandingPageLink[];
}

const EventsIndexPage: FunctionComponent<IProps> = ({ items }) => (
  <Page>
    <Header level={1} style={{ fontSize: 44 }}>
      Events
    </Header>
    <LandingPageLinkIndex items={items} />
  </Page>
);

export default EventsIndexPage;
